// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--bvRE0","link":"link--kXhbS","icon":"icon--D80wP","small":"small--mSY0d","medium":"medium--VWa5n","large":"large--Ar6yk","fadeSlideUp":"fadeSlideUp--_ewFx"};